// extracted by mini-css-extract-plugin
export default {"container":"SwitchLine_container__sicEU","title":"SwitchLine_title__Tio7I"};